import { useState, FC } from 'react';
import { Expander } from '@appd/uik';
import { useDashboardJson } from '../../../hooks';
import { getTemplateParts } from '../../../utils';
import { DemoItemProps } from './models';
import { Dashboard, DashboardJson, Datasource } from '../../models';
import DemoDatasources from './DemoDatasources';
import DemoCode from './DemoCode';
import DemoTags from './DemoTags';
import mitt from 'mitt';
import { TemplateRenderer } from '../DashboardViewer';
import { logger } from '../../../utils';

const emitter = mitt();
emitter.on('*', (type, e) => logger.log('emitter event', type, e));

// TODO: Align with Magnetic (https://www.figma.com/file/XqID1OLr22b7ouCitfkRi3/07---%F0%9F%8C%8E-FSO-Components?node-id=702%3A97747&mode=dev)
// TODO: clean up UI in DASHUI-4939
export const Demo: FC<DemoItemProps> = ({ templateName }) => {
  const json: DashboardJson | undefined = useDashboardJson({ name: templateName });
  const [showDatasources, setShowDatasources] = useState(false);
  const [showCode, setShowCode] = useState(false);
  if (!json) {
    return <div>Demo '{templateName}' not found</div>;
  }

  const { datasources, description, spec, title, tags, view } = getTemplateParts(json);
  const template = {
    spec: {
      datasources: datasources ?? {},
      view: spec['templateView'] ?? view ?? {},
    },
  } as unknown as Dashboard;

  return (
    <div
      key={templateName}
      className="bg-default-bg relative rounded overflow-hidden grid grid-rows-1 gap-2 leading-1 p-2 m-2"
    >
      <div className="w-full overflow-hidden flex flex-col bg-inherit">
        <div className="flex flex-row font-medium font-sans min-h-[36px] items-center gap-4">
          <div className="text-xl">{title}</div>
          {tags && tags.length > 0 && <DemoTags tags={tags} />}
        </div>
        {description && description.length > 0 && <div className="pt-2">{description}</div>}
        <div className="mt-4 bg-inherit">
          <TemplateRenderer name={templateName} />
        </div>
        {datasources && (
          <Expander
            className="mt-4"
            onClick={setShowDatasources}
            open={showDatasources}
            title="Show Datasources"
            titleType="section"
          >
            <DemoDatasources datasources={datasources as Record<string, Datasource>} />
          </Expander>
        )}
        {!spec.hideCode && (
          <Expander className="mt-4" onClick={setShowCode} open={showCode} title="Show Code" titleType="section">
            <DemoCode template={template} />
          </Expander>
        )}
      </div>
    </div>
  );
};
